const clearButton = {
  data() {
    return {
      // clearButtonTextColor: "cancelColor",
      // clearButtonColor: "cancelColor",
      clearButtonLabel: "Limpar",
    };
  },
  computed: {
    clearButtonTextColor() {
      return this.$vuetify.theme.isDark ? "white" : "cancelColor";
    },
    clearButtonColor() {
      return this.$vuetify.theme.isDark ? "white" : "cancelColor";
    },
  },
};

export default clearButton;
